import useAuthContext from '@salesforce/commerce-sdk-react/hooks/useAuthContext';
import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import { isClient } from '../../utils/utils';
import { bffPost } from '../bff';
import type { RecaptchaPayload } from '../../recaptcha/recaptcha';
import type { GiftCardBalance } from './model/GiftCardCheckBalance';

export interface GiftCardBalanceWithRecaptcha extends GiftCardBalance {
    recaptcha?: RecaptchaPayload;
}

export const useGiftCardCheckBalance = (): UseMutationResult<
    GiftCardBalance,
    unknown,
    GiftCardBalanceWithRecaptcha
> => {
    const authContext = useAuthContext();

    return useMutation({
        mutationFn: async (body: GiftCardBalanceWithRecaptcha) => {
            if (isClient) {
                await window.sfccSessionCreationPromise;
            }

            const { access_token } = await authContext.ready();

            return bffPost('/gift-card/check-balance', {
                accessToken: access_token,
                body,
            });
        },
    });
};
